import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
// import {Alert} from 'react-native';

export default () => muster()
  .path('currencies.saveCurrency', {
    call: async ({ req }, { get, set, call }) => {
      const { currency } = req.args[0];
      const [success] = await getValues(get([`roster.data.currencies.saveCurrency.${currency}`]));
      if (success) {
        await set('auth.destinationCurrency', currency === 'default' ? undefined : currency);
        /* WMCE-4427: dashboard pref Currency changed from settings. */
        await set('userprofile.prefCurrency', currency === 'default' ? undefined : currency)
        // alert("The view currency preference has been changed however the portfolio performance figures are shown in the original reference currency");
        // await call('ui.history.replace', { pathname: '/profile' });
      }
    }
   }
  );
